import DriverListModal from './driverList';
import ISAEditModal from './isaEdit';
import CTNEditModal from './ctnEdit';
import ShippingStatusEditModal from './shippingStatusEdit';
import Notes from './Notes';
import LocationChange from './LocationChange';
import InboundDateChange from './InboundDateChange';
import BatchesModal from './BatchesModal';
import DeliveryTimeChange from './DeliveryTimeChange';
import PickupTimeChange from './PickupTimeChange';
import ExcelUploadOption from './ExcelUploadOption';
import LabelPrintModal from './LabelPrintModal';
import ShippingRateModal from './ShippingRateModal';
import PromotionAddingModal from './PromotionAddingModal';

const salesOrderModals = {
  DriverListModal,
  ISAEditModal,
  CTNEditModal,
  ShippingStatusEditModal,
  Notes,
  LocationChange,
  InboundDateChange,
  BatchesModal,
  DeliveryTimeChange,
  PickupTimeChange,
  ExcelUploadOption,
  LabelPrintModal,
  ShippingRateModal,
  PromotionAddingModal,
}

export default salesOrderModals;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/index.jsx